(() => {
  const sticky = document.getElementById('MobileStickyATC');
  const stickyBtn = document.getElementById('MobileStickyATCButton');
  if (!sticky || !stickyBtn) return;

  const getProductInfo = () => document.querySelector('main product-info');

  const getMainAtcButton = () => {
    const pi = getProductInfo();
    if (!pi) return null;
    // innerhalb product-info suchen => weniger Risiko falschen Button zu treffen
    return pi.querySelector('.product-form__submit');
  };

  const getFooter = () =>
    document.querySelector('footer, .footer');

  const show = () => {
    sticky.classList.add('is-visible');
    sticky.setAttribute('aria-hidden', 'false');
  };

  const hide = () => {
    sticky.classList.remove('is-visible');
    sticky.setAttribute('aria-hidden', 'true');
  };

  const isPurchasable = () => {
    const mainBtn = getMainAtcButton();
    if (!mainBtn) return false;

    const disabled =
      mainBtn.hasAttribute('disabled') ||
      mainBtn.getAttribute('aria-disabled') === 'true';

    return !disabled;
  };

  stickyBtn.addEventListener('click', () => {
    const mainBtn = getMainAtcButton();
    if (mainBtn && isPurchasable()) mainBtn.click();
  });

  let atcObserver;
  let footerObserver;
  let btnStateObserver;

  let atcIsVisible = true;
  let footerIsVisible = false;

  const syncVisibility = () => {
    // Wenn Button nicht existiert oder nicht kaufbar => Sticky nie zeigen
    if (!isPurchasable()) {
      hide();
      return;
    }
    if (footerIsVisible) {
      hide();
      return;
    }
    if (atcIsVisible) hide();
    else show();
  };

  const observeButtonState = (btn) => {
    if (btnStateObserver) btnStateObserver.disconnect();
    if (!btn) return;

    btnStateObserver = new MutationObserver(() => {
      syncVisibility();
    });

    btnStateObserver.observe(btn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  };

  const setupObservers = () => {
    const mainBtn = getMainAtcButton();

    // Intersection für Main-ATC
    if (atcObserver) atcObserver.disconnect();
    if (mainBtn) {
      atcObserver = new IntersectionObserver(
        ([entry]) => {
          atcIsVisible = entry.isIntersecting;
          syncVisibility();
        },
        { threshold: 0, rootMargin: '0px 0px -10px 0px' }
      );
      atcObserver.observe(mainBtn);
    } else {
      // wenn kein Button: Sticky aus
      atcIsVisible = true;
      hide();
    }

    // Button-state observer (disabled/aria changes)
    observeButtonState(mainBtn);

    // Footer observer
    const footer = getFooter();
    if (footerObserver) footerObserver.disconnect();
    if (footer) {
      footerObserver = new IntersectionObserver(
        ([entry]) => {
          footerIsVisible = entry.isIntersecting;
          syncVisibility();
        },
        { threshold: 0 }
      );
      footerObserver.observe(footer);
    } else {
      footerIsVisible = false;
    }

    // initial korrekt setzen
    syncVisibility();
  };

  window.addEventListener('load', setupObservers);

  // Variant / option changes: nach Render-Update nochmal Observer neu ansetzen
  const productInfo = getProductInfo();
  if (productInfo) {
    productInfo.addEventListener('variant:change', () => {
      // Dawn kann DOM ersetzen -> neu attachen
      requestAnimationFrame(setupObservers);
    });

    productInfo.addEventListener('change', (e) => {
      const el = e.target;
      if (!el) return;
      if (el.matches('select, input[type="radio"], input[type="hidden"]')) {
        // manchmal 2 ticks nötig
        requestAnimationFrame(() => requestAnimationFrame(setupObservers));
      }
    });
  }

  // Shopify Section Re-render
  document.addEventListener('shopify:section:load', setupObservers);
  document.addEventListener('shopify:section:reorder', setupObservers);
})();
